import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { Shift } from '@app/shared/models/shift.model';

@Injectable()
export class ShiftAdapter implements Adapter<Shift> {
    adapt(data: any): Shift {
        return {
            id: data.id || 0,
            name: data.name || '',
            description: data.description || '',
            version: data.version || 0,
            startTime: data.startTime || 0,
            durationHs: data.duration || 0,
            daysOfWeek: data.days || [],
            hrefs: {
                self: data.href || '',
            },
        } as Shift;
    }
}
